'use client'
import React, { useState } from 'react'
import { motion } from 'framer-motion'
import Image from 'next/image'
import Link from 'next/link'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { StyledWrapper } from '@/components/Styled'

const IndustriesSeo = ({ industries, title ,subtitle }: any) => {
    const [isExpanded, setIsExpanded] = useState(false)
    return (
        <div className='w-full mb-8 border-b-[1px] border-t-[2px] border-slate-200'>
            <div className="p-7 py-8 w-full lg:w-[95%] 2xl:w-[80%] mx-auto">
                {/* Title Section with Toggle Icon */}
                <div 
                    className="flex justify-between mb-16 items-center cursor-pointer"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <h2 className="text-3xl font-bold text-homeblack">{title || 'Industries We Serve in SEO'}</h2>
                    <div className='bg-blue text-white p-2 rounded-lg'>
                    {isExpanded ? <ChevronUp size={28} /> : <ChevronDown  size={28} />}
                    </div>
                </div>
                <StyledWrapper>
                <div className='text-homegrey text-center' dangerouslySetInnerHTML={{__html:subtitle}}>
                </div>
                </StyledWrapper>
                {/* Collapsible Content */}
                <motion.div 
                    initial={false}
                    animate={{ height: isExpanded ? 'auto' : 0, opacity: isExpanded ? 1 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`overflow-hidden mt-6`}
                >
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {industries.map((industry: any, index: any) => (
                            <motion.div
                                key={index}
                                className="p-6 bg-lightblue rounded-lg hover:shadow duration-300 cursor-pointer flex flex-col items-center text-center"
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: isExpanded ? 1 : 0, y: isExpanded ? 0 : 50 }}
                                transition={{ delay: index * 0.1, duration: 0.2 }}
                                whileHover={{ scale: 1.05 }}
                            >
                                <div className="text-4xl mb-4">
                                    <Image src={industry.image || industry.icon || ''} height={40} width={40} alt={industry?.icon_alt||''} />
                                </div>
                                <h3 className="text-xl text-blue font-semibold">
                                    <Link href={industry?.title_link || ''}>{industry.name || industry.title}</Link>
                                </h3>
                                <div className={`mt-2 text-homeblack text-start`} dangerouslySetInnerHTML={{ __html: industry.description }}></div>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default IndustriesSeo
